import {Injectable} from '@angular/core';
import {Menu} from "@root/layout/nav/menu.config";
import {BehaviorSubject} from "rxjs";
import {share} from "rxjs/operators";
import {ACLService} from "@delon/acl";

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private change$: BehaviorSubject<Menu[]> = new BehaviorSubject<Menu[]>([]);
  private data: Menu[];

  get change() {
    return this.change$.pipe(share());
  }

  get menus(): Menu[] {
    return this.data;
  }

  constructor(
  ) {
  }

  set(items: Menu[]) {
    this.data = items;
    this.change$.next(this.data);
  }

  private visit(menus: Menu[], cb: (item: Menu) => void) {
    const inFn = (list: Menu[]) => {
      for (const item of list) {
        cb(item);

        if (item.children && item.children.length) {
          inFn(item.children);
        } else {
          item.children = [];
        }
      }
    }

    inFn(menus);
  }

  getHit(menus: Menu[], url: string, recursive: boolean, cb) {
    let item: Menu = null;
    while (!item && url) {
      this.visit(menus, i => {
        if (cb) {
          cb(i);
        }
        if (i.link !== null && i.link === url) {
          item = i;
        }
      });

      if (!recursive) { break; }

      if (/[?;]/g.test(url)) {
        url = url.split(/[?;]/g)[0];
      } else {
        url = url.split('/').slice(0, -1).join('/');
      }
    }

    return item;
  }

  getItem(key: string): Menu {
    let res: Menu | null = null;
    this.visit(this.data, item => {
      if (res == null && item.key === key) {
        res = item;
      }
    });
    return res;
  }

  setItem(key: string, value: Menu): void {
    const item = this.getItem(key);
    if (item == null) { return; }

    Object.keys(value).forEach(k => {
      item[k] = value[k];
    });

    this.change$.next(this.data);
  }

  removeItem(key: string) {
    this.data = this.data.filter(menu => menu.key !== key);
    console.log('menu data: ', this.data)
    this.change$.next(this.data);
  }
}
